import { useQuery } from "@tanstack/react-query";
import { fetchFilingsQueue } from "../api/filings";
import type { FilingsQueueResult } from "../api/filings";

export function useFilingsQueue() {
  return useQuery<FilingsQueueResult>({
    // Under the matters prefix, so every writer that already invalidates
    // ["matters"] (claim, merge, intake) refreshes the queue too.
    queryKey: ["matters", "filings"],
    queryFn: fetchFilingsQueue,
    staleTime: 60_000,
  });
}
